import { midi } from '../midi/MidiBus';
import { noteOff, noteOn } from '../midi/generate';
import { Scheduler, type ScheduleEntry } from './Scheduler';

export const MIDI_CHANNEL = 1;

/** Plays back scheduled entries as sequencer-sourced MIDI. */
function playEntries({ entries }: { entries: ScheduleEntry[] }): void {
  for (const entry of entries) {
    midi.send({ ...entry.data, source: 'sequencer', timestamp: performance.now() });
  }
}

/** The user's loop recorder. */
export const musicRecorder = new Scheduler();
musicRecorder.on('tick', playEntries);

/** Count-in metronome for sampling. Runs once, not looped. */
export const countIn = new Scheduler();
countIn.loop = false;

/** A canned ascending major scale, played by the DEMO button. */
export const demoTrack = new Scheduler();
demoTrack.on('tick', playEntries);

const MAJOR_STEPS = [2, 1, 2, 2, 1, 2, 2];
const DEMO_NOTE_SPACING = 80;
const DEMO_NOTE_LENGTH = 60;

{
  let note = 51;
  demoTrack.length = 0;
  for (let i = 0; i < 21; i++) {
    demoTrack.addToSchedule(noteOn(note, 100, MIDI_CHANNEL, 'sequencer'), i * DEMO_NOTE_SPACING);
    demoTrack.addToSchedule(
      noteOff(note, 0, MIDI_CHANNEL, 'sequencer'),
      i * DEMO_NOTE_SPACING + DEMO_NOTE_LENGTH,
    );
    demoTrack.length += DEMO_NOTE_SPACING;
    note += MAJOR_STEPS[i % MAJOR_STEPS.length];
  }
}
